export interface PendingStateInterface {
  isPending: boolean;
}

export const initPendingState: PendingStateInterface = {
  isPending: false,
};
